var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn btn-print"},[_c('button',{on:{"click":function($event){return _vm.onClick()}}},[_vm._v("\n    "+_vm._s(_vm.$t('printBtnText'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }